<!-- Шаблон создания/редактирования записи на прием сотрудником -->


<template>

	<section v-if="isEditModal">

		<div class="back_lay" @click="closeModal()"></div>

		<!-- Modal -->
		<div class="modal modal_shadow">
			<div class="modal__header clear_fix">
				<user-avatar :data="doctor.user" class="modal__avatar"></user-avatar>
				<div class="modal__title">
					{{doctor.user_last_name}} {{doctor.user_first_name}} {{doctor.user_middle_name}}
				</div>
			</div>

			<!-- Outer -->
			<div class="modal__outer">

				<div class="modal__inner clear_fix flex" v-show="isNew">

					<div class="modal__box modal__box_pos fl_l">
						<div class="modal__title modal__title_mr">Дата</div>
						<div class="modal__text-field modal__text-field_blue">
							{{[visit.begin, 'X'] | moment('DD.MM')}}
						</div>
					</div>

					<div class="modal__box modal__box_pos fl_l">
						<div class="modal__title modal__title_mr">Время</div>
						<change-time :date="visit.begin" @inputTime="updateBegin"
												 class="modal__text-field modal__text-field_blue"></change-time>
					</div>
				</div>

				<div class="modal__inner clear_fix" v-if="isNew">
					<div class="modal__title modal__title_mr">Выберите пациента</div>
					<input class="modal__text-field" placeholder="Начните вводить телефон или имя"
								 @input="findUser(search)" v-model="search"/>

					<div class="modal__result" v-if="isSearch">
						<div class="modal__result-item" v-for="user in users" :track-by="user._id" @click="selectUser(user),newVisitBalance(user)">
							{{user.last_name}} {{user.first_name | one}} {{user.middle_name | one}},
							{{user.birthday | age}}, +{{user.phone}}
						</div>
					</div>

					<a v-show="isNew && !selected" @click="addNewUser" class="modal__link modal__link_blue">
						+ Создать нового пациента
					</a>
				</div>

				<div class="modal__inner clear_fix">
					<div class="basic-box__inner flex">
						<div class="modal__title modal__title_mr">Длительность приема, мин</div>

						<!--Timer-->
						<div class="timer flex">
							<div class="timer__minus-btn" @click="decreaseDuration">
								<i class="timer__icon icon ion-minus-round"></i>
							</div>

							<div class="timer__time-value">{{duration}}</div>

							<div class="timer__plus-btn" @click="increaseDuration">
								<i class="timer__icon icon ion-plus-round"></i>
							</div>
						</div>
						<!--Timer End-->

					</div>
				</div>

				<div class="modal__inner">
					<form class="modal__form">
					
					    <!-- New design for payment block -->
					    <div class="modal__inner flex">
					        <div class="modal__payment_item">
					            <div class="modal__payment_title text-center">Стоимость приема</div>
					            <input type="number" class="modal__text-field" placeholder="0" v-model.number="visit.price">
					        </div>
					        <div class="modal__payment_item">
					            <div class="modal__payment_title">Внесено</div>
					            <input type="number" class="modal__text-field" placeholder="0" v-model.number="visit.deposit">
					        </div>
					        <div class="modal__payment_item">
					            <div class="modal__payment_title">Баланс клиента</div>
					            <input type="number" class="modal__text-field" placeholder="Введите стоимость приема" v-model.number="balance">
					        </div>
                        </div>
                        
						<label class="modal__label">Коментарий</label>

						<textarea class="modal__text-area" placeholder="Введите текст" v-model="visit.description"></textarea>
						
						

						<div class="modal__btn-wrap">
							<button type="button" class="modal__btn modal__btn_decor" @click="createMomentVisit"
											v-show="isMoment && isNew">
								Начать прием
							</button>
							<button type="button" class="modal__btn modal__btn_decor" @click="createVisit(true)"
											v-show="!isMoment && isNew">
								Создать запись
							</button>
							<button type="button" class="modal__btn modal__btn_decor" @click="editVisit(visit._id)" v-show="!isNew">
								Редактировать запись
							</button>
						</div>

						<!--<p class="modal__basic-text modal__basic-text_red modal__basic-text_pos">-->
						<!--Пожалуйста выберите время-->
						<!--</p>-->

					</form>
				</div>
			</div>
			<!-- Outer End -->
			<i class="modal__icon_close icon ion-close trans" @click="closeModal()"></i>
		</div>
		<!-- Modal End -->

	</section>

</template>

<script>
    import moment from 'moment'
    import ChangeTime from "../commonComponents/changeTime.vue"

    export default {
        components: {
            ChangeTime
        },
        name: 'EditModal',
        computed: {
            clinicId() {
                return this.$route.query.clinic || this.$storage.get('clinic')
            },
            clinic() {
                return this.$store.state.auth.clinic
            },
            user() {
                return this.$store.state.auth.user
            },
            worker() {
                return this.$store.state.auth.worker
            },
            isInquiry() {
                return (this.doctor.can === 'by_request')
            }
        },
        mounted() {
            this.$event.connect('openEditModal', (visit, doctor) => {
                this.doctor = doctor;
                this.visit = visit;
                this.isEditModal = true;
                    this.balance = 0;

                if (visit._id && !visit.isInquiry) {
                    this.search = visit.users[0].first_name + ' ' + visit.users[0].last_name;
                    this.duration = moment(this.visit.end, 'X').diff(moment(this.visit.begin, 'X'), 'minutes');
                    this.selected = true;
                    this.isNew = false;
                    this.getBalance(visit);
                } else if (visit.isInquiry) {
                    this.search = visit.user.first_name + ' ' + visit.user.last_name;
                    this.patient = visit.user;

                    this.getDuration(doctor._id);
                    this.visit.description = '';
                    this.visit.price = '';
                    this.visit.deposit = '';
                    this.selected = false;
                    this.isNew = true;
                } else {
                    this.getDuration(doctor._id);
                    this.selected = false;
                    this.isNew = true;
                }
            })

            this.$event.connect('openMomentModal', (visit, doctor) => {
                this.isMoment = true
                this.isEditModal = true
                this.visit = visit
                this.doctor = doctor
                this.getDuration(doctor._id)
            });

            this.$event.connect('userModalResponse', (user) => {
                if (!user._id) return false

                this.isEditModal = true
                this.patient = user
                this.search = user.first_name + ' ' + user.last_name
                this.selected = true
            })
        },
        beforeDestroy() {
            this.$event.disconnect(['openEditModal', 'openMomentModal', 'userModalResponse']);
        },
        data() {
            return {
                isEditModal: false,
                isSearch: false,
                selected: false,
                isNew: true,
                isMoment: false,
                showStaffResult: false,
                isShowSearchStaffField: false,

                visit: {
                    access: false,
                    begin: 0
                },
                doctor: {
                    can: 'no'
                },
                supportDoctor: {},

                doctors: [],

                duration: 0,
                balance: 0,

                users: [],
                staffs: [],
                patient: {},
                search: '',
                searchStaff: ''
            }
        },
        methods: {
            createMomentVisit() {
                if (!this.patient._id || !this.duration) {
                    this.$event.toast('i', "Выберите пациента и длительность визита")
                    return false
                }

                this.doctors.push(this.doctor._id)

                if (this.supportDoctor._id)
                    this.doctors.push(this.supportDoctor._id)

                this.createAgenda({
                    workerIds: this.doctors,
                    userIds: [this.patient._id],
                    clinicId: this.clinic._id,
                    status: 'came'
                }).then(visit => {
                    this.isMoment = false
                    this.$router.push({
                        path: 'card',
                        query: {
                            patient: this.patient._id,
                            doctor: this.doctor._id,
                            visit: visit._id
                        }
                    })
                })
            },
            createVisit(isDoctor) {
                this.doctors = []
                this.doctors.push(this.doctor._id)

                if (this.supportDoctor._id)
                    this.doctors.push(this.supportDoctor._id)

                if (isDoctor)
                    this.createByDoctor()
                else
                    this.createByUser()
            },
            createByDoctor() {
                if (this.visit.isInquiry) {
                    this.visit.patient = this.patient
                    this.createInquiry(this.visit)
                } else {
                    this.createAgenda({
                        workerIds: this.doctors,
                        userIds: [this.patient._id],
                        clinicId: this.clinic._id,
                        status: 'not_confirmed'
                    }).then(() => {
                        this.$event.send('updateEvents', this.doctor._id)
                        this.closeModal()
                    })
                }
            },
            createByUser() {
                //				if (this.doctor.can === 'by_request') {
                //					this.visit.patient = this.user
                //					this.createInquiry(this.visit)
                //				} else {
                this.createAgenda({
                    workerIds: this.doctors,
                    userIds: [this.user._id],
                    clinicId: this.clinicId,
                    status: 'confirmed'
                }).then(() => {
                    this.$event.send('updateEvents', this.doctor._id)
                    this.closeModal()
                })
                //				}
            },
            createAgenda(visit) {
                return this.$store.dispatch('agenda/create', {
                    worker_ids: visit.workerIds,
                    user_ids: visit.userIds,
                    clinic_id: visit.clinicId,
                    begin: this.visit.begin,
                    end: moment(this.visit.begin, 'X').add(this.duration, 'minutes').format('X'),
                    status: visit.status,
                    description: this.visit.description,
                    price: this.visit.price,
                    deposit: this.visit.deposit,
                    access: this.visit.access
                })
            },
            createInquiry(inquiry) {
                if (inquiry.isInquiry) {
                    inquiry.status = 'processed'

                    return this.$store.dispatch('inquiry/update', inquiry).then(() => {
                        this.$event.send('updateEvents', this.doctor._id)
                        this.$event.send('updateInquiryList', this.doctor._id)
                        this.closeModal()
                    })
                }

                return this.$store.dispatch('inquiry/create', {
                    worker_id: this.doctor._id,
                    user_id: inquiry.patient._id,
                    clinic_id: this.clinicId,
                    begin: this.visit.begin,
                    end: moment(this.visit.begin, 'X').add(this.duration, 'minutes').format('X')
                }).then(() => {
                    this.$event.send('updateEvents', this.doctor._id)
                    this.closeModal()
                })
            },
            editVisit(id) {
                this.$store.dispatch('agenda/update', {
                    id: id,
                    clinic_id: this.visit.clinic_id,
                    user_ids: this.visit.user_ids,
                    worker_ids: this.visit.worker_ids,
                    begin: this.visit.begin,
                    end: moment(this.visit.begin, 'X').add(this.duration, 'minutes').format('X'),
                    status: this.visit.status,
                    description: this.visit.description,
                    price: this.visit.price,
                    deposit: this.visit.deposit,
                }).then(() => {
                    this.$event.send('updateEvents', this.doctor._id)
                    this.closeModal()
                })
            },
            selectUser(user) {
                this.patient = user
                this.search = user.first_name + ' ' + user.last_name
                this.isSearch = false
                this.selected = true
            },
            addDoctor(staff) {
                this.supportDoctor = staff
                this.searchStaff = staff.user.first_name + ' ' + staff.user.last_name
                this.showStaffResult = false
            },
            getDuration(id) {
                this.$api.get('worker/' + id).then((response) => {
                    this.duration = response.time
                })
            },
            findUser(user) {
                if (user.length < 3) {
                    this.isSearch = false
                    return false
                }

                this.$store.dispatch('user/byName', user).then(response => {
                    this.isSearch = true
                    this.selected = false
                    this.users = response
                    console.log(this.users)
                    this.users = this.users.filter(function(item) {
                        return (item.last_name ? item.last_name.toLowerCase().includes(user.toLowerCase()) : false) 
                        || (item.phone ? item.phone.toLowerCase().includes(user.toLowerCase()) : false) 
                    })
                })
            },
            findDoctor(staff) {
                if (staff.length < 3) {
                    this.showStaffResult = false
                    return false
                }

                this.$api.post('worker/list', {
                    search_name: staff
                }).then(response => {
                    this.staffs = response.data
                    this.showStaffResult = true
                })
            },
            decreaseDuration() {
                if (this.duration)
                    this.duration = +this.duration - 5
            },
            increaseDuration() {
                this.duration = +this.duration + 5
            },
            addNewUser() {
                this.$event.send('openClientModal', {}, 'agenda')
                this.closeModal(true)
            },
            showSearchField() {
                this.isShowSearchStaffField = true
            },
            updateBegin(time) {
                this.visit.begin = time;
            },
            closeModal(save) {
                this.isEditModal = false;

                if (!save) {
                    this.isEditModal = false;
                    this.isSearch = false;
                    this.selected = false;
                    this.isNew = true;
                    this.isMoment = false;
                    this.isDoctor = false;
                    this.isShowSearchStaffField = false;

                    this.patient = {};
                    this.users = [];
                    this.search = '';
                    this.visit = {
                        access: false
                    };
                    this.duration = 0;
                }
            },
            getBalance(visit) {
                this.$store.dispatch('agenda/list', {
                    user_ids: visit.user_ids,
                    clinic_id: visit.clinic_id,
                    status: 'completed'
                }).then((res) => {
                    res.data.forEach(({ deposit = 0, price = 0 }) => {
                       this.balance += (deposit - price); 
                    });
                });
            },
            //Code from Michael
            newVisitBalance(user) {
                this.$store.dispatch('agenda/list', {
                    user_ids: [user._id],
                    clinic_id: this.clinic._id,
                    status: 'completed'
                }).then((res) => {
                    res.data.forEach(({ deposit = 0, price = 0 }) => {
                       this.balance += (deposit - price);
                    });
                });
            }
            //End code from Michael
        }
    }
</script>

<style scoped>
    .modal {
        z-index: 510;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
    }
</style>

<style>
    .overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 505;
        width: 100vw;
        height: 100%;
        background: #000;
        opacity: 0.4;
    }
</style>


// WEBPACK FOOTER //
// EditModal.vue?089aa24b